<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <page-header
          title="Refunds"
          :return_button="false"
          :action_button="false"
          action_button_text=""
          action_button_link=""
        ></page-header>
        <div class="row">
          <div class="col-md-12">
            <div v-if="!loading.page && refunds.length > 0">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Action</th>
                    <th scope="col">Order No.</th>
                    <th scope="col">Status</th>
                    <th scope="col" class="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="refund in refunds" :key="refund.id">
                    <th scope="row">{{ refund.id }}</th>
                    <td>{{ refund.action }}</td>
                    <td class="fw-bolder">{{ refund.order_id }}</td>
                    <td>{{ refund.status_code }}</td>
                    <td class="text-end">
                      <a :href="`/staff/refunds/${refund.id}/view`">
                        <i class="bi-pencil-square fs-5 text-primary me-2"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <ul class="pagination justify-content-center mt-5">
                  <li v-if="pagination.currentPage > 1" class="page-item">
                    <a
                      class="page-link"
                      href="#"
                      aria-label="Previous"
                      @click.prevent="changePage(pagination.currentPage - 1)"
                    >
                      <span aria-hidden="true">«</span>
                    </a>
                  </li>
                  <li
                    class="page-item"
                    v-for="page in pagination.totalPages"
                    :key="page"
                    :class="{ active: page == pagination.currentPage }"
                  >
                    <a
                      v-if="
                        page < 3 ||
                        page > pagination.totalPages - 3 ||
                        (page < pagination.currentPage + 3 &&
                          page > pagination.currentPage - 3)
                      "
                      class="page-link"
                      @click.prevent="changePage(page)"
                      >{{ page }}</a
                    >
                  </li>
                  <li
                    v-if="pagination.currentPage < pagination.totalPages"
                    class="page-item"
                  >
                    <a
                      class="page-link"
                      aria-label="Next"
                      @click.prevent="changePage(pagination.currentPage + 1)"
                    >
                      <span aria-hidden="true">»</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <center-message v-else-if="refunds.length == 0"
              >No refunds found.</center-message
            >
            <loader v-if="loading.page"> </loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/layout/navigation/PageHeader.vue";
import Loader from "@/components/Loader.vue";
import RefundService from "@/services/customer/RefundService";
import CenterMessage from "@/components/CenterMessage.vue";

export default {
  name: "ListRefundsView",
  components: {
    PageHeader,
    Loader,
    CenterMessage
  },

  data() {
    return {
      loading: {
        page: false,
      },
      refunds: [],
      pagination: {
        currentPage: 1,
        perPage: 12,
        totalRows: 0,
        totalPages: 0,
      },
    };
  },

  async mounted() {
    await this.getRecords();
    this.loading.page = false;
  },

  methods: {
    async getRecords(search) {
      this.loading.page = true;
      if (search === true) {
        this.pagination.currentPage = 1;
      }

      let response = await RefundService.getRefunds(
        this.pagination.currentPage,
        this.pagination.perPage
      );

      this.refunds = response.data.refunds.data;
      this.pagination.totalRows = response.data.refunds.total;
      this.loading.page = false;
      this.pagination.totalPages = response.data.refunds.last_page;
    },

    changePage(page) {
      if (this.pagination.currentPage != page) {
        this.pagination.currentPage = page;
        this.getRecords();
      }
    },
  },
};
</script>
